import moment from 'moment'
import { Message } from 'element-ui'
import deptApi from 'public/utils/dept-api'
import store from '../../store'
import { http } from '../../utils/http'
import { random, createModel, getModelValue } from '../../utils'
import { deepMergeAxios, addHeadersIdToHitInterface } from '../../utils/dept-api-code-trace'
import { AXIOS } from '@/public/utils/common-api'
// 判断组织树权限是否走规则的集合
let departmentTreeRuleIds = null
// 首页的menuId
const HomePageMenuId = '2820215716730110'

// 权限组织树接口的headers头参数
const deptTreeAxios = {
  axios: {
    headers: {
      'X-menu-id': HomePageMenuId
    }
  }
}

// 判断当前模块是否走首页数据权限
const isUseHomePageMenuId = (menuId) => {
  return Array.isArray(departmentTreeRuleIds) && !departmentTreeRuleIds.includes(menuId)
}

// 修改 本地的 axios.headers['X-menu-id']
function setDeptTreeAxios () {
  let menuId = window.__ERPMODULE__.id || ''
  if (menuId) {
    deptTreeAxios.axios.headers['X-menu-id'] = menuId
  }
  if (!Array.isArray(departmentTreeRuleIds)) {
    return deptTreeAxios
  }
  // 如果规则中存在当前的menuId,则使用本身
  if (isUseHomePageMenuId(menuId)) {
    deptTreeAxios.axios.headers['X-menu-id'] = HomePageMenuId
  }
  return deptTreeAxios
}

// 查询组织树权限规则的方法，根据规则修改 X-menu-id
function queryDeptTreeCustomRuleResIds() {
    try {
      if (Array.isArray(departmentTreeRuleIds)) {
        return new Promise(resolve => {
          resolve(setDeptTreeAxios())
        })
      }
      return http('auth.business.departmentTreeConfig.getCustomRuleResIds', { time: random() }, { ...AXIOS, log: false, cancel: true }).then(res => {
        departmentTreeRuleIds = res || []
        return setDeptTreeAxios()
      })
    } catch (e) {
      console.error('[queryTable-queryDeptTreeCustomRuleResIds]', e)
      return new Promise(resolve => {
        resolve(setDeptTreeAxios())
      })
    }
}


// 部门负责人Tree
let authTreePromise = null

// 按照菜单缓存组织树tree
let preloadDeptTree = {}

// 白名单
let hadAllTreeAuth = null

export const HTTP_ACTION = {
  FORM: 1, // 自定义查询表单
  GENERIC: 2, // 通用查询弹框表单
  PAGER: 3, // 分页组件
  SORT: 4, // 表头排序
  REFRESH: 5, // 调用loadData刷新列表
  TIMEOUT: 6, // 轮训
}

// 通用查询-操作 system_genericsearch_operation
export const OPERATIONS = {
  equal: 'equal',
  not_equal: 'not_equal',
  greaterthan: 'greaterthan',
  greaterthanorequal: 'greaterthanorequal', // 大于等于
  lessthan: 'lessthan',
  lessthanorequal: 'lessthanorequal', // 小于等于
  contain: 'contain',
  not_contain: 'not_contain',
  between: 'between',
  not_between: 'not_between'
}

export const OPERATION_LABELS = {
  equal: '等于',
  not_equal: '不等于',
  greaterthan: '大于',
  greaterthanorequal: '大于等于',
  lessthan: '小于',
  lessthanorequal: '小于等于',
  contain: '包含于',
  not_contain: '不包含',
  between: '范围于',
  not_between: '非范围于'
}

// 通用查询值类型 system_GenericQuery_ValueType
export const COLUMN_TYPE = {
  number: 'number',
  string: 'string',
  enum: 'enum',
  date: 'date',
  phone: 'phone',
  area: 'area',
  user: 'user',
  department: 'department',
  dept: 'dept',
  customComponent: 'customComponent'
}

export const COMPARES = {
  enum: [
    OPERATIONS.equal,
    OPERATIONS.not_equal,
    OPERATIONS.contain,
    OPERATIONS.not_contain
  ],
  string: [
    OPERATIONS.equal,
    OPERATIONS.not_equal,
    OPERATIONS.contain,
    OPERATIONS.not_contain
  ],
  number: [
    OPERATIONS.equal,
    OPERATIONS.not_equal,
    OPERATIONS.greaterthan,
    OPERATIONS.greaterthanorequal,
    OPERATIONS.lessthan,
    OPERATIONS.lessthanorequal,
    OPERATIONS.between
  ],
  date: [
    OPERATIONS.equal,
    OPERATIONS.greaterthan,
    OPERATIONS.greaterthanorequal,
    OPERATIONS.lessthan,
    OPERATIONS.lessthanorequal,
    OPERATIONS.between
  ],
  phone: [
    OPERATIONS.equal
  ],
  area: [
    OPERATIONS.equal
  ],
  user: [
    OPERATIONS.equal,
    OPERATIONS.not_equal
  ],
  department: [
    OPERATIONS.equal,
    OPERATIONS.not_equal
  ],
  dept: [
    OPERATIONS.equal
  ],
  customComponent: [
    OPERATIONS.equal
  ]
}

export const SINGLE_VALUE = [
  COLUMN_TYPE.string,
  COLUMN_TYPE.phone,
  COLUMN_TYPE.user,
  COLUMN_TYPE.department
]

// 组件宽度默认值
const WIDTH_MAP = {
  text: 145, // 文本输入框
  number: 60, // 数字输入框
  select: 157, // 下拉选择框
  remoteSelect: 157, // 远程搜索框
  rangeMenu: 60, // 区间下拉选择
  range: 200, // 区间多选
  year: 60, // 日期格式 yyyy
  month: 80, // 日期格式 yyyy-MM
  date: 98, // 日期格式 yyyy-MM-dd
  datetime: 132, // 日期格式 yyyy-MM-dd HH:mm
  daterange: 168, // 日期区间格式 [yyyy-MM-dd, yyyy-MM-dd]
  datetimerange: 237, // 日期区间格式 [yyyy-MM-dd HH:mm, yyyy-MM-dd HH:mm]
  monthrange: 130, // 日期区间格式 [yyyy-MM, yyyy-MM]
  time: 78, // 时间格式 HH:mm:ss
  timerange: 135, // 时间区间格式 [HH:mm:ss, HH:mm:ss]
  user: 82, // 员工搜索组件
  department: 95 // 部门搜索组件
}

// 新版日期组件适配规则
const DATE_WIDTH = {
  date: 100,
  month: 90,
  months: 136,
  datetimerange: 250, // 日期区间格式 [yyyy-MM-dd HH:mm, yyyy-MM-dd HH:mm]
  daterange: 180, // 日期区间格式 [yyyy-MM-dd, yyyy-MM-dd]
  monthrange: 150 // 日期区间格式 [yyyy-MM, yyyy-MM]
}

const DATE_WIDTH3 = {
  date: 100,
  dates: 156, // 日期格式 [yyyy-MM-dd, yyyy-MM-dd]
  month: 90,
  months: 136,
  year: 64,
  week: 96,
  datetimerange: 260, // 日期区间格式 [yyyy-MM-dd HH:mm, yyyy-MM-dd HH:mm]
  daterange: 184, // 日期区间格式 [yyyy-MM-dd, yyyy-MM-dd]
  monthrange: 150 // 日期区间格式 [yyyy-MM, yyyy-MM]
}


// 通过按钮权限过滤页面展示字段
export function filterFieldsByAuthCode (fields, type) {
  const getLookup = (item) => {
    // 通用查询前端属性
    let attribute2 = item.attribute2
    if (attribute2) {
      if (typeof attribute2 === 'string') {
        try {
          attribute2 = JSON.parse(attribute2)
        } catch (e) {
          console.error('[query-table]', e)
        }
      }
    }
    return item.hideLookup || (attribute2 && attribute2.hideLookup) || ''
  }

  const func = data => data.filter(item => {
    const hideLookup = getLookup(item)

    // 自定义列
    if (type === 'column' && Array.isArray(item.children) && item.children.length) {
      item.children = func(item.children)
    }

    // 自定义查询
    if (type === 'query' && item.type === 'menu' && Array.isArray(item.options) && item.options.length) {
      item.options = func(item.options)
    }

    const hasAuth = (hideLookup) => {
      // 数据字典
      const employeeNumber = store.getters.user.employeeNumber
      const arr = store.getters.lookUpOptions[hideLookup] || []
      return arr.some(e => e.value === employeeNumber)
    }

    return hideLookup ? !hasAuth(hideLookup) : true
  })


  try {
    let data = fields
    // 过滤子级为空情况
    data = func(fields).filter(v => {
      if (type === 'column') {
        return !(v.children && Array.isArray(v.children) && v.children.length === 0)
      }
      if (type === 'query') {
        return !(v.type === 'menu' && Array.isArray(v.options) && v.options.length === 0)
      }
      return true
    })

    return data
  } catch (e) {
    console.error('[query-table]', e)
    return fields
  }
}

/**
 * 获取远程下拉框
 * @param v
 * @param model
 */
export const getRemoteOptions = (v, model) => {
  v.remoteMethod(model).then(e => {
    if (!e || !e.length) {
      v.options = []
      return
    }
    if (typeof e[0] === 'object') {
      // [{}]，数组每一项是对象
      v.labelKey && v.valueKey && e.forEach(k => {
        k.label = k[v.labelKey]
        k.value = k[v.valueKey]
      })
    } else {
      // ['']，数组每一项是基本类型
      e = e.map(k => ({ label: k, value: k }))
    }
    v.options = e
  })
}

/**
 * 远程搜索下拉框
 * @param val
 * @param v
 * @returns {Promise<Array>}
 */
export const remoteSelectMethod = async (val, v) => {
  val = (val && val.trim()) || ''
  let len = v.inputLength || (v.$attr && v.$attr.inputLength) || 2
  if (val && val.length < len) {
    Message.warning(`请至少输入${len}个字符`)
    v.options = []
    return Promise.resolve(v.options)
  }
  if (val && typeof v.remoteMethod === 'function') {
    v.loading = true
    let arr = await v.remoteMethod(val, v)
    v.loading = false
    if (!arr || !arr.length) {
      v.options = []
      return Promise.resolve(v.options)
    }
    if (typeof arr[0] === 'object') {
      // [{}]，数组每一项是对象
      v.labelKey && v.valueKey && arr.forEach(k => {
        // 2022-12-06 通用查询新增 labelKey valueKey属性，但是由于业务线可能对数据进行了处理，导致可能无法取到 labelKey valueKey字段
        k.label = k[v.labelKey] || k.label
        k.value = k[v.valueKey] || k.value
      })
    } else {
      // ['']，数组每一项是基本类型
      arr = arr.map(k => ({ label: k, value: k }))
    }
    v.options = arr
    // 2022-05-24 缓存远程下拉数据，用来回显
    // 自定义查询与通用查询规则不同
    if ((v.attr && v.attr.multiple) || (v.$attr && v.$attr.multiple)) {
      let oldObj = v.allSearchResult || Object.create(null)
      let newObj = v.options.reduce((prev, cur) => {
        prev[cur.value] = cur
        return prev
      }, {})
      v.allSearchResult = { ...oldObj, ...newObj }
    }
    return Promise.resolve(v.options)
  }
  v.options = []
  return Promise.resolve(v.options)
}

/**
 * 补全 通用查询 的逻辑参数
 * @param vos
 */
export const perfectVos = vos => {
  let len = vos.length - 1
  vos.forEach((v, i) => {
    if (i < len && !v.conditionOperation) {
      v.conditionOperation = 'and'
    } else if (i === len) {
      v.conditionOperation = ''
    }
    if (!v.frontBrackets) {
      v.frontBrackets = '('
    }
    if (!v.postBrackets) {
      v.postBrackets = ')'
    }
  })
}

/**
 * 构造 通用查询 参数
 * @param fields
 * @param model
 * @param generic
 * @returns {{generic: {vos: Array}}}
 */
export const mapGenericSearchParams = (fields, model, generic = {}) => {
  let vos = []
  if (model) {
    fields.forEach(v => {
      if (v.show) {
        if (v.type === 'menu' && v.options) {
          let item = v.options[v.$index || 0]
          if (item && item.columnType && item.operation) {
            if (item.type === 'range') {
              let operation = ''
              let values = []
              item.options && item.options.forEach(m => {
                let val = getModelValue(model, m.propertyName)
                if (val || val === 0) {
                  operation = m.operation
                  values.push(val)
                }
              })
              if (operation) {
                if (values.length > 1) {
                  operation = item.operation
                }
                mapGenericVos(model, vos, item, { operation, values })
              }
            } else {
              mapGenericVos(model, vos, item)
            }
          }
          return
        }
        if (v.type === 'range') {
          let operation = ''
          let values = []
          v.options && v.options.forEach(k => {
            let val = getModelValue(model, k.propertyName)
            if (val || val === 0) {
              operation = k.operation
              values.push(val)
            }
          })
          if (operation) {
            if (values.length > 1) {
              operation = v.operation
            }
            mapGenericVos(model, vos, v, { operation, values })
          }
          return
        }
        if (v.type === 'rangeMenu' && v.options) {
          let item = v.options[v.$index || 0]
          v.operation = item.operation
          mapGenericVos(model, vos, v)
          return
        }
        if (v.type === 'area') {
          let areas = getModelValue(model, v.propertyName)
          areas && v.options && areas.forEach((val, i) => {
            if (val.id) {
              mapGenericVos(model, vos, v.options[i], { values: [val.id] })
            }
          })
          return
        }
        if (v.type === 'user') {
          let areas = getModelValue(model, v.propertyName)
          areas && v.options && areas.forEach((val, i) => {
            mapGenericVos(model, vos, v.options[i], { values: [val.id] })
          })
          return
        }
        mapGenericVos(model, vos, v)
      }
    })
  }
  perfectVos(vos)
  return { generic: { ...generic, vos } }
}

/**
 * 构造 非通用查询 参数
 * @param fields
 * @param model
 * @returns {{}}
 */
export const mapFormModelParams = (fields, model) => {
  let vo = {}
  let arr = []
  if (model) {
    fields.forEach(v => {
      if (v.show) {
        if (v.type === 'menu' && v.options) {
          parseValueKey(arr, v.options[v.$index || 0], model)
          return
        }
        if (v.type === 'area') {
          let flag = v.options && v.options.some(k => (!k.columnType || !k.operation))
          if (flag) {
            let areas = getModelValue(model, v.propertyName)
            areas && areas.forEach((val, i) => {
              if (val.id) {
                arr.push({
                  key: v.options[i].propertyName,
                  default: val.id
                })
              }
            })
          }
          return
        }
        parseValueKey(arr, v, model)
      }
    })
  }
  return arr.length ? createModel(arr, 'key') : vo
}

/**
 * 扁平化 区间列
 * @param rows
 * @param sectionOption
 */
export const mapSectionValueList = (rows, sectionOption) => {
  if (sectionOption && rows) {
    let row_key = sectionOption.row
    let key_key = sectionOption.key
    let value_key = sectionOption.value
    let $row_key = sectionOption.$row
    rows.forEach(v => {
      if (v[row_key] && v[row_key].length) {
        v[$row_key] = v[row_key].reduce((s, k) => {
          s[k[key_key]] = k[value_key]
          return s
        }, {})
      } else {
        v[$row_key] = {}
      }
    })
  }
}

/**
 * 处理后台数据
 * 容错: [null, {}] -> [{}, {}]
 * @param res
 * @returns {*}
 */
export const perfectRows = (res) => {
  if (Array.isArray(res)) {
    res = { rows: res, rowTotal: res.length }
  }
  res.rows = (res && res.rows) || []
  res.rows.forEach((v, i) => {
    if (!v) {
      res.rows[i] = {}
    }
  })
  return res
}

/**
 * 补全 自定义查询表单 默认配置
 * @param vm
 * @param v
 */
export const perfectField = (vm, v) => {
  // 员工、部门
  if (v.columnType === 'user') {
    v.width = v.customWidth || WIDTH_MAP['user']
    v.columnType = 'string'
    v.labelKey = 'label'
    v.valueKey = v.valueKey || 'id'
    let fn = v.formatterOption || (v => `${v.chineseName}，${v.position || ''}，${v.departmentName}，${v.employeeNumber}`)
    let data = v.formatData || (val => ((/^\d{4,}$/.test(val)) ? { employeeNumber: val } : { chineseName: val }))
    v.remoteMethod = val => vm.$http('data.employee.listByName', data(val)).then(res => {
      if (res && res.length) {
        // 20：离职，排后面
        res.sort((a, b) => a.status - b.status)
        // 展示所有搜索结果
        // res = res.slice(0, 10)
        res.forEach(c => {
          c.optionDisabled = c.status === '20'
          c.label = fn(c)
        })
      }
      return res
    })
  } else if (v.columnType === 'department') {
    v.width = v.customWidth || WIDTH_MAP['department']
    v.columnType = 'string'
    v.labelKey = 'label'
    v.valueKey = v.valueKey || 'id'
    let fn = v.formatterOption || (v => `${v.name}，${v.departmentCode}`)
    v.remoteMethod = val => vm.$http('hr.department.refactoring.getByFuzzyValue', { fuzzyValue: val }).then(res => {
      res && res.forEach(c => c.label = fn(c))
      return res
    })
  }
  // 远程搜索
  if (v.remoteMethod) {
    vm.$set(v, 'loading', false)
    vm.$set(v, 'options', [])
  }
  if (v.type === 'select' && !v.remoteMethod) {
    // 支持配置 select options
    if (Array.isArray(v.options) && v.options.length) {
      console.log('自定义查询', v.label, v.propertyName, v.options)
    } else if (v.lookupCode) {
      let arr = vm.lookUpOptions[v.lookupCode] || []
      // null 查询
      if (!v.unNull) {
        arr = arr.concat({ label: '(空)', value: 'null' })
      }
      v.options = arr
    } else if (!v.options) {
      vm.$set(v, 'options', [])
    }
  }
  // 日期单位为月，自动设置 yyyy-MM
  if (v.type === 'datePicker') {
    let type = v.dateType
    if (type === 'month') {
      v.format = v.valueFormat = 'yyyy-MM'
    } else if (v.format === 'yyyy-MM' && type && type.includes('range')) {
      type = 'monthrange'
    }
    if (type && type.includes('time')) {
      if (v.format2) {
        v.format = v.format2
        v.width = v.customWidth || WIDTH_MAP[type] + (type.includes('range') ? 31 : 16)
      } else {
        v.format = 'yyyy-MM-dd HH:mm'
        v.width = v.customWidth || WIDTH_MAP[type]
      }
    } else {
      v.width = v.customWidth || WIDTH_MAP[type || 'time']
    }
  }

  if (v.type === 'datePicker2') {
    let type = v.dateType || 'date'
    let format = v.format || 'yyyy-MM-dd'
    let valueFormat = v.valueFormat
    if (type === 'month' || type === 'months') {
      format = valueFormat = 'yyyy-MM'
    }
    if (type === 'datetimerange') {
      format = 'yyyy-MM-dd HH:mm'
    }
    if (type === 'daterange') {
      if (!valueFormat) {
        valueFormat = 'yyyy-MM-dd'
      }
    }
    if (v.format === 'yyyy-MM' && type && type.includes('range')) {
      type = 'monthrange'
      format = valueFormat = 'yyyy-MM'
    }
    v.startPlaceholder = v.openPlaceholder ? v.startPlaceholder : ' '
    v.endPlaceholder = v.openPlaceholder ? v.endPlaceholder : ' '
    v.dateType = type
    v.format = format
    v.valueFormat = valueFormat
    v.width = v.customWidth || DATE_WIDTH[type]
  }

  if (v.type === 'datePicker3') {
    let type = v.dateType || 'date'
    let format = ''
    let format2 = ''
    let valueFormat = ''

    v.startPlaceholder = v.openPlaceholder ? (v.attr && v.attr.startPlaceholder) : ' '
    v.endPlaceholder = v.openPlaceholder ? (v.attr && v.attr.endPlaceholder) : ' '
    v.dateType = type
    v.format = v.format || (v.attr && v.attr.format) || format
    v.format2 = v.format2 || (v.attr && v.attr.format2) || format2
    v.valueFormat = v.valueFormat || (v.attr && v.attr.valueFormat) || valueFormat
    v.width = v.customWidth || DATE_WIDTH3[type]
  }
  // 单行不用这个功能
  // 2021-07-23 默认不开启
  v.placeholder = v.openPlaceholder ? v.placeholder : ' '
  setFieldWidth(v) // 宽度处理
}

/**
 * 构造 通用查询 vos
 * @param model
 * @param vos
 * @param v
 * @param v2
 */
const mapGenericVos = (model, vos, v, v2) => {
  if (!v.columnType || !v.operation) {
    return
  }
  let val = ''
  let operation = v.operation
  if (v2) {
    val = v2.values
  } else {
    val = getModelValue(model, v.propertyName)
    // 2022-01-19 时间区间保留单边属性处理
    if (Array.isArray(val) && (v.dateType === 'datetimerange' || v.dateType === 'daterange')) {
      if (val[0] && !val[1]) {
        operation = 'greaterthanorequal'
        val = [val[0]]
      }
      if (!val[0] && val[1]) {
        operation = 'lessthanorequal'
        val = [val[1]]
      }
      if (!val[0] && !val[1]) {
        return
      }
    }

    if (!Array.isArray(val) && (val || val === 0)) {
      val = [val]
    }
  }
  if (val && val.length) {
    let vo = {
      propertyName: v.propertyName,
      columnName: v.columnName,
      frontBrackets: v.frontBrackets,
      postBrackets: v.postBrackets,
      conditionOperation: v.conditionOperation,
      operation,
      type: v.columnType,
      values: val,
      ...v2
    }
    // 组织类型扩展参数
    if (v.type === 'dept') {
      const key = v.propertyName
      const contain = model[`_deptContainLeaf_${key}`]
      const idsInfo = model[`_deptInfo_${key}`]
      if (idsInfo !== null && contain !== null) {
        vo.containLeaf = contain
        vo.contain = contain
        vo.idsInfo = idsInfo
      }
    }
    // 扩展字段
    if (v.attribute1 && typeof v.attribute1 === 'object') {
      Object.assign(vo, v.attribute1)
    }
    vos.push(vo)
  }
}

/**
 * 详情页通用查询分页器对象
 * @param idKey
 * @param rows
 * @returns {{total, ids, query}}
 */
export const getQueryPager = (idKey, rows) => {
  let pager = { total: rows.length }
  if (typeof idKey === 'object' && typeof idKey.func === 'function') {
    // {idKey: 'xx.xx', func: row => ({xx: 'xx'})}
    let ids = []
    let key = idKey.idKey || 'id'
    pager.query = rows.reduce((s, v) => {
      let id = `${getModelValue(v, key)}`
      ids.push(id)
      s[id] = idKey.func(v)
      return s
    }, {})
    pager.ids = ids
  } else {
    pager.ids = rows.map(v => `${getModelValue(v, idKey)}`)
  }
  return pager
}

const parseValueKey = (arr, v, model) => {
  if (v && (!v.columnType || !v.operation)) {
    let keys = v.valueKey
    let val = getModelValue(model, v.propertyName)
    if (keys && Array.isArray(keys)) {
      val && keys.forEach((k, i) => {
        arr.push({
          key: k,
          default: val[i]
        })
      })
    } else {
      arr.push({
        key: v.propertyName,
        default: val
      })
    }
  }
}

const setFieldWidth = (v) => {
  let width = v.width
  let type = v.type
  if (width && type !== 'menu') {
    v.width = parseInt(width) + 'px'
    return
  }
  if (type === 'timePicker') {
    width = v.customWidth || WIDTH_MAP['time' + (v.dateType || '')]
  } else if (type === 'area' && v.options && v.options.length) {
    let len = v.options.length
    width = len <= 3 ? 118 * len : 118 * 3 + 180 * (len - 3)
  } else if (type === 'menu' && v.options && v.options.length) {
    v.options.forEach(c => {
      let cwidth = c.width
      if (!cwidth) {
        let ctype = c.type
        if (ctype === 'datePicker' || ctype === 'timePicker') {
          cwidth = c.customWidth || WIDTH_MAP[c.dateType || 'time' + (v.dateType || '')]
        } else {
          cwidth = c.customWidth || WIDTH_MAP[ctype]
        }
      }
      c.width = parseInt(cwidth) + 'px'
    })
    width = v.options[0].width
  } else {
    width = v.customWidth || WIDTH_MAP[type]
  }
  v.width = parseInt(width) + 'px'
}

/**
 * select 自动选中第一个子项
 * @param vm: select 组件实例
 */
export const navigateSelectFirstOption = (vm, index) => {
  if (vm && vm.$refs && vm.$refs[`remoteSelect${index}`] && vm.$refs[`remoteSelect${index}`].navigateOptions) {
    // kye-select
    vm.$refs[`remoteSelect${index}`].navigateOptions('next')
  } else if (vm && vm.navigateOptions) {
    // el-select
    vm.navigateOptions('next')
  }
}

/**
 * 根据通用查询模板生成通用查询参数
 * @param arr
 * @param fields
 * @param esFlag
 * @returns {Array}
 */
export const appendGenericVosByTemplate = (arr, fields, esFlag) => {
  const vos = []
  if (!arr || !fields) {
    return vos
  }

  let key = esFlag ? 'propertyName' : 'columnName'
  const componentMap = {
    [COLUMN_TYPE.user]: COLUMN_TYPE.string,
    [COLUMN_TYPE.department]: COLUMN_TYPE.string,
    [COLUMN_TYPE.phone]: COLUMN_TYPE.string
  }

  arr.forEach(v => {
    let field = fields.find(f => f.key === v[key])
    let values = v.queryValue
    if (!field || !values) {
      return false
    }
    let type = field.columnType
    let vo = {
      propertyName: v.propertyName,
      columnName: v.columnName,
      frontBrackets: v.frontBrackettemplates,
      postBrackets: v.postBrackets,
      conditionOperation: v.conditionOperation,
      operation: v.operation,
      type: componentMap[type] || type
    }
    // 将模板字符串形式的值解析为数组
    if (type === COLUMN_TYPE.user || type === COLUMN_TYPE.department) {
      try {
        let arr = JSON.parse(values)
        values = [arr[0].value]
      } catch (e) {
        values = values.split(',')
        console.error('[queryTable-appendGenericVosByTemplate]', e)
        throw e
      }
    } else {
      values = values.split(',')
    }
    // merge 扩展字段的参数
    if (field.attribute1) {
      try {
        Object.assign(vo, JSON.parse(field.attribute1))
      } catch (e) {
        console.error('[queryTable-appendGenericVosByTemplate]', e)
        throw e
      }
    }
    // 组装通用查询参数
    if (type === COLUMN_TYPE.area) {
      let options = field.$attr.options
      let lastIndex = values.length - 1
      values.forEach((id, index) => {
        if (id) {
          let opt = options[index]
          vos.push({
            propertyName: opt.propertyName,
            columnName: opt.columnName,
            frontBrackets: '(',
            postBrackets: ')',
            conditionOperation: index === lastIndex ? v.conditionOperation : 'and',
            operation: v.operation,
            type: opt.columnType,
            values: [v]
          })
        }
      })
    } else {
      vo.values = values
      vos.push(vo)
    }
  })
  return vos
}

// 扁平化组织树
export function mapDepts (result, data, arr = []) {
  if (!result[data.id]) {
    let id = data.id
    result[id] = {
      ...data,
      id,
      pid: data.parentId,
      ids: id,
      name: data.name,
      children: data.children && data.children.map(v => v.id)
    }
  }
  return arr.reduce((o, v) => {
    let cArr = v.children
    let id = v.id
    let pid = v.parentId
    o[id] = {
      ...v,
      id,
      pid,
      ids: `${o[pid] && o[pid].ids},${id}`,
      name: v.name
    }
    if (cArr && cArr.length) {
      o[id].children = cArr.map(v => v.id)
      return mapDepts(result, data, cArr)
    }
    return o
  }, result)
}

// 获取指定组织的所有后代
export function getPosterity (map, arr, ids) {
  return ids.reduce((s, v) => {
    s.push(v)
    let children = map[v] && map[v].children
    if (children) {
      return getPosterity(map, arr, children)
    }
    return s
  }, arr)
}

export function fetchTreeData (auth) {
  if (auth) {
    return deptApi.getAuthOrgTreeData()
  }

  return deptApi.getAllOrgTreeData(true)
}

/**
 * 判断是否有获取全量组织树的权限
 * @returns {boolean}
 */
export function hasAllTreeAuth () {
  if (hadAllTreeAuth !== null) {
    return hadAllTreeAuth
  }
  const number = store.getters.user.employeeNumber
  const arr = store.getters.lookUpOptions['hrms_department_lookup'] || []
  hadAllTreeAuth = arr.some(e => e.value === number)
  return hadAllTreeAuth
}

/**
 * field配置项fetchAxios返回的数据格式说明
 * {
 *   data: {bakMonth: '2020-01'}, // 接口参数
 *   ... // 其他属性为 http 方法第三个参数为对象时的属性，比如{cancel,log,axios}
 * }
 * @param field
 * @returns Object
 */
export function runFetchAxios (field) {
  let func = (field && field.fetchAxios) || (field && field.$attr && field.$attr.fetchAxios)
  if (func) {
    let conf = func(field)
    let { bakMonth } = conf.data || {}
    if (bakMonth && bakMonth >= '2019-10') {
      let now = moment().format('YYYY-MM')
      return bakMonth < now ? conf : null
    }
  }
  return null
}

/**
 * 通用查询组织树的公共接口，仅供通用查询组织树弹框调用
 *
 * 1. auth: true, 调用有权限控制的接口
 * 2. 非白名单用户调用 hr.department.refactoring.getAllDepartmentLeastAsTreeWithAuth
 * 3. field: 配置项需要按月份并且 2019-10>=bakMonth<当前年月，调用历史组织树接口。（2019-10月前服务器没有存历史数据）
 * 4. 不满足上述两种情况下，调用通用接口获取实时的组织树
 *
 * @param auth
 * @param field
 * @returns Promise
 */
export async function fetchGenericTreeData (auth, field, axios, allTreeAuth) {
  const deptAxios = await queryDeptTreeCustomRuleResIds()
  let menuId = window.__ERPMODULE__.id || ''
  const authUrl = 'hr.department.refactoring.getAllDepartmentLeastAsTreeWithAuth'
  // 1. 有权限控制的接口
  let mergeAxios = {
    ...deptAxios, // headers的x-menu-id参数
    ...axios, // 用户配置的axios 优先级最高
  }
  // 2023-02-01 增加组织树接口标识，用于区分是否在公共组件中调用该接口
  mergeAxios = deepMergeAxios(mergeAxios, addHeadersIdToHitInterface(authUrl))
  // 获取缓存组织树，判断缓存组织树取值
  let deptTree = preloadDeptTree[menuId]
  if (isUseHomePageMenuId(menuId)) {
    deptTree = preloadDeptTree[HomePageMenuId]
  }
  if (auth) {
    return deptTree || http(authUrl, { time: random() }, mergeAxios)
  }
  // 2. 没有获取全量组织树的权限时，先判断是否是白名单用户
  const hasAllTree = hasAllTreeAuth() || allTreeAuth
  if (!hasAllTree) {
    // 当前菜单下组织树是否已经预加载
    if (deptTree) {
      return deptTree
    }
    if (!authTreePromise) {
      authTreePromise = http(authUrl, { time: random() }, mergeAxios)
    }
    return authTreePromise
  }
  // 3. 判断是否需要获取历史数据
  let bakMonthConf = runFetchAxios(field)
  if (bakMonthConf) {
    const url = 'hr.departmentBak.getAllTreeByMonth'
    bakMonthConf = deepMergeAxios(bakMonthConf, addHeadersIdToHitInterface(url))
    return http(url, bakMonthConf.data, bakMonthConf)
  }

  return deptApi.getAllOrgTreeData(true)
}
/**
 * 2021-10-14 预加载全量组织树
 */
export function setGenericTreeData () {
  setTimeout(() => {
    deptApi.getAllOrgTreeData(true)
  }, 3000)
}

export function encodeKey (str) {
  if (!str) return ''
  return window.btoa(window.encodeURIComponent(str))
}

export function setPreloadDeptTree () {
  try {
    let menuId = window.__ERPMODULE__.id || ''
    if (!menuId || preloadDeptTree[menuId]) return

    // 判断当前模块首页组织树是否存在
    if (isUseHomePageMenuId(menuId) && preloadDeptTree[HomePageMenuId]) {
      return
    }

    // 表达调用了获取规则的接口，根据规则重置menuId
    queryDeptTreeCustomRuleResIds().then((axios = {}) => {
      const url = 'hr.department.refactoring.getAllDepartmentLeastAsTreeWithAuth'
      axios = deepMergeAxios(axios, addHeadersIdToHitInterface(url))
      http(url, { time: random() }, { log: false, cancel: true, ...axios }).then(res => {
        // 目前大部分组织权限是走首页数据权限，判断是否储存首页的权限组织树
        if (isUseHomePageMenuId(menuId)) {
          preloadDeptTree[HomePageMenuId] = Promise.resolve(res)
        } else {
          preloadDeptTree[menuId] = Promise.resolve(res)
        }
      })
    })
  } catch (error) {
    console.error('[queryTable-setPreloadDeptTree]', error)
    throw error
  }
}

/**
 * @description: 通过传入一个字符串或正则表达式，生成一个oninput事件，用于限制输入框输入内容
 * @param  pattern 字符串或正则表达式
 * @return { oninput: string }
 */
export const createOnInputReplacer = (pattern) => ({ oninput: `this.value=this.value.replace(${pattern}, '');` })



// WEBPACK FOOTER //
// ./src/public/components/query-table/utils.js